import React from  "react";
import Paper from 'material-ui/Paper';

export default class PrivacyPolicy extends React.Component {
  render() {
    return(
      <Paper zDepth={5} style={{marginTop:'40',marginBottom:'40',display: 'inline-block', padding: 40}}>
      <h1>
          {`Privacy Policy`}
      </h1>
        <p>
          {
            `Party Poker MyGame aims to provide the world's safest and most innovative gaming platform. With our fair and responsible product line-up, every user can play within their financial means and receive the best service possible. partpoker MyGame commits itself to integrity, fairness and reliability and we always do our best to prevent gaming-related problems.
            Together with leading research institutes, associations and counselling providers, we have developed measures that ensure a responsible, safe and reliable place for online gaming.`
          }
        </p>
          <h4>
              {`1] Real Fairness`}
          </h4>
          <p>
            {'It is our responsibility to create a gaming environment that is founded on the spirit of fair play. The trust of our customers is fundamental to our success. Customer confidence is reliant on us safeguarding the fairness of the games and protecting our customers against fraud. We work closely with independent authorities which monitor the fairness of the gaming products we offer. When it comes to fraud and manipulation, our dedicated investigation and online monitoring teams ensure your protection'}
          </p>
          <h4>
              {`2] Real security`}
          </h4>
          <p>
            {'partpoker  is subject to strict regulatory oversight and we comply with a wide range of laws, rules, standards and regulations throughout various jurisdictions. Regular verification of compliance by means of independent reviews confirms that random number generators work as they should, that your deposits are kept safe in segregated accounts and that your personal data is protected.'}
          </p>
          <h4>
              {`3] Real prevention`}
          </h4>
          <p>
            {'Gaming is a great source of entertainment for millions of people around the world. But, for a minority, gaming can cause problems. We are committed to identifying risks as early as possible and intervening to prevent these problems before they emerge. We have in place a Responsible Gaming framework which includes controls to help customers to play within their limits and avoid a situation where gaming causes problems. As with everything we do, we believe that protective measures must be based on sound science. That’s why we had been the first company to cooperate with scientists to analyse actual online gaming behaviour and develop an evidence-based responsible gaming concept.'}
          </p>
      </Paper>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/PrivacyPolicy.js
 **/